import BaseModel from './BaseModel';

export default class SensorConnectModel extends BaseModel {
  init(data) {
    this.id = data.id || 0;
    this.active = 'active' in data ? data.active : false;
  }
}
